import { NgModule } from "@angular/core";
import { SharedModule } from "../shared/shared.module";
import { RouterModule } from "@angular/router";
import { AuthGuard } from "../auth-guard.service";
import { AccountGuard } from "../account-guard.service";
import { UsersComponent } from "./users.component";
import { MydetailsComponent } from "./mydetails.component";
import { UserService } from "./user.service";

@NgModule({
  imports:[      
        SharedModule,
        RouterModule.forChild([
          {path:'users',component: UsersComponent, canActivate:[AuthGuard,AccountGuard]},
          {path:'mydetails',component: MydetailsComponent, canActivate:[AuthGuard,AccountGuard]}
        ])
    ],
    exports: [
        
    ],
    declarations: [
        UsersComponent,
        MydetailsComponent
    ],
    providers: [        
        UserService
    ]
})
export class UsersModule{

}



// WEBPACK FOOTER //
// ./src/app/users/users.module.ts